import { render, staticRenderFns } from "./PuzzleOptionArrowsModal.vue?vue&type=template&id=35ee8c32&scoped=true&"
import script from "./PuzzleOptionArrowsModal.vue?vue&type=script&lang=js&"
export * from "./PuzzleOptionArrowsModal.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleOptionArrowsModal.vue?vue&type=style&index=0&id=35ee8c32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ee8c32",
  null
  
)

export default component.exports